export default __webpack_public_path__ + "static/media/Feature1.8c8744aa.svg";